export const roleList = (assignedSubmissionOwner: boolean) => [
  {
    title: "Client Profile Permissions",
    key: "client_profile_permissions",
    permissions: [
      {
        title: "Create/Edit",
        subtitle: "Create/Edit client profiles",
        value: "client_profile_create",
      },
      {
        title: "View",
        subtitle: "View client profile information",
        value: "client_profile_view",
      },
      {
        title: "Merge",
        subtitle: "Merge client profiles",
        value: "client_profile_merge",
      },
      {
        title: "Delete",
        subtitle: "Delete client profiles",
        value: "client_profile_delete",
      },
    ],
  },
  {
    title: "Packets & Forms Building Permissions",
    key: "packets_forms_building_permissions",
    permissions: [
      {
        title: "Create/Edit",
        subtitle: "Create/Edit forms and packets",
        value: "packet_form_building_create",
      },
      {
        title: "Disable",
        subtitle: "Disable forms and packets",
        value: "packet_form_building_disable",
      },
      {
        title: "Delete",
        subtitle: "Delete forms and packets",
        value: "packet_form_building_delete",
      },
    ],
  },
  {
    title: "Form & Packet Submission Permissions",
    key: "form_packet_submission_permissions",
    permissions: [
      {
        title: "Send",
        subtitle: "Send Forms and Packets",
        value: "packet_form_submission_send",
      },
      {
        title: "View",
        subtitle: "View pending and received submissions",
        value: "packet_form_submission_view",
      },
      {
        title: "Archive",
        subtitle: "Archive completed submissions",
        value: "packet_form_submission_archive",
      },
      {
        title: "Delete",
        subtitle: "Delete pending and received submissions",
        value: "packet_form_submission_delete",
      },
      {
        title: "Export PDF",
        subtitle: "Export filled forms as a PDF",
        value: "packet_form_submission_export_pdf",
      },
      {
        title: "CSV Export Access",
        subtitle: "Create and export data via CSV export",
        value: "packet_form_submission_export_csv",
      },
    ],
  },
  {
    title: "Report Data",
    key: "report_data",
    permissions: [
      {
        title: "View Client List",
        subtitle: "View and filter client lists",
        value: "report_data_view_client_list",
      },
      {
        title: "View Submission Report",
        subtitle: "View and filter submission lists",
        value: "report_data_view_submission_report",
      },
    ],
  },
  {
    title: "Settings",
    key: "settings",
    permissions: [
      {
        title: "General Settings",
        subtitle: "View and edit general settings",
        value: "settings_general_setting",
      },
      {
        title: "Team",
        subtitle: "Invite, remove and view users",
        value: "settings_team_user",
      },
      {
        title: "Automations",
        subtitle: "Create, edit and view automations",
        value: "settings_automation",
      },
      {
        title: "Integrations",
        subtitle: "Connect, edit and view integrations",
        value: "settings_integration",
      },
      ...(assignedSubmissionOwner
        ? [
            {
              title: "User Assigned Form Visibility",
              subtitle: "Users can only see forms that they are assigned to",
              value: "settings_user_assigned_form_visibility",
            },
          ]
        : []),
    ],
  },
];

export const permissionList = (assignedSubmissionOwner: boolean) => {
  const permissionList: Record<string, string[]> = {};

  roleList(assignedSubmissionOwner).forEach(({ key, permissions }) => {
    permissionList[key] = permissions.map((permission) => permission.value);
  });

  return permissionList;
};
